import React, { useState, useEffect, createContext, useMemo } from "react";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import { LightTheme, DarkTheme } from "./Themes";

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [themeMode, setThemeMode] = useState(() => {
    if (typeof window === 'undefined') return 'light';
    const savedMode = localStorage.getItem('themeMode');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    return savedMode || (prefersDark ? 'dark' : 'light');
  });

  const toggleTheme = () => {
    setThemeMode(prevMode => prevMode === 'light' ? 'dark' : 'light');
  };

  useEffect(() => {
    localStorage.setItem('themeMode', themeMode);
  }, [themeMode]);

  const theme = useMemo(() => 
    themeMode === 'light' ? LightTheme : DarkTheme,
    [themeMode]
  );

  const contextValue = useMemo(() => ({
    theme: themeMode,
    toggleTheme,
  }), [themeMode]);

  return (
    <ThemeContext.Provider value={contextValue}>
      <MuiThemeProvider theme={theme}>
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};